import Shimmer from "@components/core/Shimmer/Shimmer";
import ShimmerWrapper from "@components/core/Shimmer/ShimmerWrapper";

// Mirrors the Edit job posting panel: title bar, color field + image button row, advanced row.
const StyleThemeSkeleton = () => {
    return (
        <ShimmerWrapper spacing={24} direction='column' align='stretch'>
            <Shimmer width='100%' height={46} radius={8} />
            <ShimmerWrapper spacing={16} direction='row' align='center' justify='space-between'>
                <Shimmer width={156} height={48} radius={10} />
                <Shimmer width={110} height={38} radius={6} />
            </ShimmerWrapper>
            <ShimmerWrapper spacing={16} direction='row' align='center' justify='space-between'>
                <Shimmer width={170} height={20} radius={6} />
                <Shimmer width={120} height={20} radius={6} />
            </ShimmerWrapper>
        </ShimmerWrapper>
    );
}

export default StyleThemeSkeleton;
